import React from "react";
import { Select } from "antd";
import { ArcherContainer, ArcherElement } from "react-archer";
import { LeftCircleOutlined, RightCircleOutlined } from "@ant-design/icons";

const MatchingQuestionAdmin = ({ pairs, links, onLinkChange }) => {
  return (
    <div style={{
      background: "#fffbe6",
      padding: 30,
      borderRadius: 12,
      boxShadow: "0 2px 10px rgba(0,0,0,0.1)",
      marginBottom: 30,
      overflowX: "auto"
    }}>
      <ArcherContainer strokeColor="#52c41a" lineStyle="arrow">
        <div style={{ display: "flex", flexDirection: "column", gap: 30 }}>
          {pairs.map((pair) => {
            const selectedRightId = links[pair.id];
            return (
              <div
                key={pair.id}
                style={{
                  display: "grid",
                  gridTemplateColumns: "1fr 1fr 1fr 1fr",
                  alignItems: "center",
                  gap: 20,
                  width: "100%"
                }}
              >
                {/* 🟩 Question gauche */}
                <ArcherElement
                  id={`left-${pair.id}`}
                  relations={
                    selectedRightId
                      ? [{
                          targetId: `right-${selectedRightId}`,
                          targetAnchor: "left",
                          sourceAnchor: "right",
                          style: { strokeColor: "#52c41a", strokeWidth: 2 }
                        }]
                      : []
                  }
                >
                  <div style={{
                    padding: "10px 16px",
                    border: "2px solid #52c41a",
                    background: "#f6ffed",
                    borderRadius: 8,
                    fontWeight: "bold",
                    display: "flex",
                    alignItems: "center"
                  }}>
                    <LeftCircleOutlined style={{ marginRight: 8 }} />
                    {pair.leftText}
                  </div>
                </ArcherElement>

                {/* 👉 Flèche vide (prise par Archer) */}
                <div />

                {/* 🟦 Réponse droite */}
                <ArcherElement id={`right-${pair.id}`}>
                  <div style={{
                    padding: "10px 16px",
                    border: "2px solid #1890ff",
                    background: "#e6f7ff",
                    borderRadius: 8,
                    fontWeight: "bold",
                    display: "flex",
                    alignItems: "center"
                  }}>
                    <RightCircleOutlined style={{ marginRight: 8 }} />
                    {pair.rightText}
                  </div>
                </ArcherElement>

                {/* 🔽 Select pour associer */}
                <Select
                  placeholder="Associer à..."
                  style={{ width: "100%", zIndex: 10 }}
                  value={selectedRightId}
                  onChange={(value) => onLinkChange(pair.id, value)}
                  options={pairs.map(p => ({
                    label: p.rightText,
                    value: p.id
                  }))}
                />
              </div>
            );
          })}
        </div>
      </ArcherContainer>
    </div>
  );
};

export default MatchingQuestionAdmin;
